import React, { useEffect } from 'react';

const ContactForm = () => {

  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'wf_anal';
    script.src =
      'https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=f4bd0ee273c2df1164a77a16c11d738cc935bf8dee1acd31a5192b2344c05a73a9b7f72fc3c626b23f4f1abfd179b6e6gid85e33f4b57b8cf358cc999bce3704f405eb8cbe923ee8247efa5a88376d15691gid893a5c5ae74107224784423af0e194f3b00fc1a0fed651b0288d17ffdfa8196bgid8636c7889e7c2187255e65094e45727c5371a7c4511e82357ca4b1608bd909ef&tw=242dd6edb21d2e5362cd0df5c7a745f360ffea65438d74c4083f15e2f7eaa207';
    script.async = true;
    document.body.appendChild(script);

    // Optional: Cleanup on unmount
    return () => {
      document.getElementById('wf_anal')?.remove();
    };
  }, []);
  
  return (
    
    <div
      id="crmWebToEntityForm"
      className="zcwf_lblLeft crmWebToEntityForm botFormStyle"
      style={{ backgroundColor: 'white', color: 'black', maxWidth: '100%', padding: '0',}}
    >
      <form
        id="webform6682728000000522787"
        action="https://crm.zoho.com/crm/WebToLeadForm"
        name="WebToLeads6682728000000522787"
        method="POST"
        onSubmit={() => {
          document.charset = "UTF-8";
          return window.checkMandatory6682728000000522787();
        }}
        acceptCharset="UTF-8"
      >
        <input className='formControl' type="hidden" name="xnQsjsdp" value="9ed7303cd1c9a60d8a1d392a2d90179e6cb66f6e3d1039ff68728fc17541cc04" />
        <input className='formControl' type="hidden" name="zc_gad" id="zc_gad" value="" />
        <input type="hidden" name="xmIwtLD" value="e73ad8e78c266d15e5738b6381ff3c53651a109c8601accf35119f2e0984e1086e9404c1e4755d3c28adc454d90f1484" />
        <input className='formControl' type="hidden" name="actionType" value="TGVhZHM=" />
        <input className='formControl' type="hidden" name="returnURL" value="https://astronglobal.com/contact-us" />

        {/* First Name */}
        <div className="zcwf_row">
          <div className="zcwf_col_lab">
            <label htmlFor="First_Name">First Name <span style={{ color: 'red' }}>*</span></label>
          </div>
          <div className="zcwf_col_fld">
            <input className='form-control' type="text" id="First_Name" name="First Name" maxLength="40" required />
          </div>
        </div>

        {/* Last Name */}
        <div className="zcwf_row">
          <div className="zcwf_col_lab">
            <label htmlFor="Last_Name">Last Name <span style={{ color: 'red' }}>*</span></label>
          </div>
          <div className="zcwf_col_fld">
            <input className='form-control' type="text" id="Last_Name" name="Last Name" maxLength="80" required />
          </div>
        </div>

        {/* Email */}
        <div className="zcwf_row">
          <div className="zcwf_col_lab">
            <label htmlFor="Email">Email <span style={{ color: 'red' }}>*</span></label>
          </div>
          <div className="zcwf_col_fld">
            <input className='form-control' type="email" id="Email" name="Email" maxLength="100" required />
          </div>
        </div>

        {/* Country */}
        <div className="zcwf_row">
          <div className="zcwf_col_lab">
            <label htmlFor="Country">Country <span style={{ color: 'red' }}>*</span></label>
          </div>
          <div className="zcwf_col_fld">
            <input className='form-control' type="text" id="Country" name="Country" maxLength="100" required />
          </div>
        </div>

        {/* Company */}
        <div className="zcwf_row">
          <div className="zcwf_col_lab">
            <label htmlFor="Company">Company <span style={{ color: 'red' }}>*</span></label>
          </div>
          <div className="zcwf_col_fld">
            <input className='form-control' type="text" id="Company" name="Company" maxLength="100" required />
          </div>
        </div>

        <div className="zcwf_row">
          <input className="zcwf_button btn btn-primary formsubmit" type="submit" value="Submit" />
        </div>
      </form>
    </div>
  );
};

export default ContactForm;